import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import "./player.scss";
import {  CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import './circularProgressbar.scss'
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "./AnimatedProgressProvider";
import {  reportAnalytics } from '../../../fundialSlice';

  
const Player = (props) => {
    const [btnStatus, setBtnStatus] = useState('btn-play');
    const [audioPercentage, setAudioPercentage] = useState(0);
    const audioId = "song-" + props.audio.id;

    useEffect(() => {
        const myAudio = document.querySelector('#' + audioId);
        var interval;
        if(myAudio && !myAudio.paused) {
            interval = setInterval(() => updateCurrent(), 0);

            if(props.showDownloadSongPopUp){
              props.reportAnalytics({
                eventCategory: 'fundial',
                eventAction: "HN_PopUp_Play",
                eventLabel: "",
              });
            }

            if(props.currentPage == "songListPage"){
              props.reportAnalytics({
                eventCategory: 'fundial',
                eventAction: "HN_ListCategories_Play",
                eventLabel: "",
              });
            }

        }
        return () => {
            clearInterval(interval);
          };
    },[btnStatus])

    useEffect(() => {
        const myAudio = document.querySelector('#' + audioId);
        if(audioPercentage == 100) {
            myAudio.pause();
            myAudio.currentTime = 0;
            setBtnStatus('btn-play');
            setAudioPercentage(0);
        } 
    },[audioPercentage])

    function togglePlay(e){
      e.stopPropagation();
      const myAudio = document.querySelector('#' + audioId);
      setBtnStatus(myAudio.paused ? 'btn-pause' : 'btn-play');
      return myAudio.paused ? myAudio.play() : myAudio.pause();
    }

    function updateCurrent(){
        const myAudio = document.querySelector('#' + audioId);
        const currentTime = myAudio.currentTime;
        const percentage = (currentTime / myAudio.duration)*100;
        setAudioPercentage(percentage.toFixed(0));   
    }

    return (
      <div className="player-wrapper" style={{backgroundImage: `url("${props.audio.image}")`, width: props.playerSize, height: props.playerSize}}>
        <div className="player" >
          {props.isDisplayPlayer && props.audio.funtonPrevUrl && 
          <AnimatedProgressProvider
            valueStart={0}
            valueEnd={audioPercentage}
            duration={0.4}
            easingFunction={easeQuadInOut}
            value={audioPercentage}
          >
            {value => {
              const roundedValue = Math.round(value);
              return (
                <CircularProgressbarWithChildren 
                  value={value}
                  styles={buildStyles({
                  // textColor: '#711769',
                  pathColor: '#e30287',
                  trailColor: '#d6d6d68c',
                  // pathTransitionDuration: 0.95,
                  pathTransition: "none",
                  rotation: 0.25,
                })} 
                >
                <audio 
                src={props.audio.funtonPrevUrl}
                id={audioId}
                />
                  <button  onClick={(e) => togglePlay(e)} style={{backgroundColor: btnStatus == 'btn-play' ? '#ffffff' : 'transparent'}}>       
                    <span  className={btnStatus}></span>
                  </button>
                </CircularProgressbarWithChildren >
              );
            }}
          </AnimatedProgressProvider>
          }
        </div>
        </div>
        ) ;


}

const mapStateToProps = (state) => {
  return {
    showDownloadSongPopUp: state.fundialPage.showDownloadSongPopUp,
    currentPage: state.fundialPage.navigation.currentPage
  };
};

const mapDispatchToProps = {
  reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(Player);
